import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Flower2, Sparkles, Star, Moon } from "lucide-react";
import { motion } from "framer-motion";

const items = [
  { to: "/remedies", label: "Herbal Remedies", icon: Flower2, testid: "remedies-quick-link" },
  { to: "/rituals", label: "Rituals", icon: Sparkles, testid: "rituals-quick-link" },
  { to: "/astrology", label: "Astrology", icon: Star, testid: "astrology-quick-link" },
  { to: "/ai-tips", label: "AI Guidance", icon: Moon, testid: "ai-tips-quick-link" },
];

const QuickActionsGrid = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.3 }}
    className="grid grid-cols-2 md:grid-cols-4 gap-4"
  >
    {items.map(({ to, label, icon: Icon, testid }) => (
      <Link to={to} key={to} data-testid={testid}>
        <Card className="glass hover:border-mystic-300/30 transition-all cursor-pointer group">
          <CardContent className="p-6 text-center">
            <Icon className="w-8 h-8 text-mystic-300 mx-auto mb-3 group-hover:text-moon-gold transition-colors" />
            <p className="text-white font-medium">{label}</p>
          </CardContent>
        </Card>
      </Link>
    ))}
  </motion.div>
);

export default QuickActionsGrid;
